import React from "react";
import { Grid, Typography } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

const PersonalInfoCard = ({ id, email, title, clickHandler }) => {
  return (
    <Grid
      container
      style={{
        borderBottom: "1px solid #EEEBEF",
        marginTop: "20px",
        paddingBottom: "20px",
        cursor: "pointer",
      }}
      // alignItems="center"
      onClick={() => clickHandler(id)}
    >
      {/* <Grid item sm={1}></Grid> */}
      <Grid item sm={2} style={{ display: "flex", justifyContent: "center" }}>
        <AccountCircleIcon
          style={{ height: "80px", width: "80px", color: "#EEEBEF" }}
        />
      </Grid>
      <Grid item sm={8}>
        <Typography style={{ fontWeight: "bold", textTransform: "capitalize" }}>
          {title}
        </Typography>
        <Typography className="mb-10">{email}</Typography>
      </Grid>
    </Grid>
  );
};

export default PersonalInfoCard;
